<template>
  <div class="page-section">
    <h1 class="info-title white">
      Help shape <b>your experience</b>
    </h1>

    <p class="section-subtitle">
      It only takes 10 seconds - and helps us personalise your journey to <b>spend better and save smarter</b>.
    </p>

    <p class="section-subtitle">
      Your feedback shapes what you see next.
    </p>

    <button class="blue-button width-80" @click="handleButtonClick">
      Help us improve <span class="arrow-right">→</span>
    </button>
  </div>
</template>

<script setup>
const emit = defineEmits(['buttonClick']);

const handleButtonClick = () => {
  emit('buttonClick');
};
</script>

<style lang="scss" scoped>
@import '../../../../scss/riseup-vars';

.page-section {
  color: white;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 35px;
  background-color: #002579;
}

.info-title {
  font-size: 36px;
  font-family: 'SalaryFinance';
  padding-top: 40px;
  padding-right: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
  line-height: 1;
}

.white {
  color: #FFFFFF;
}

.info-title b {
  font-weight: 700;
}

.section-subtitle {
  font-size: 17px;
  font-family: 'SalaryFinance';
  margin-top: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
  color: #FFFFFF;
}

.section-subtitle b {
  font-weight: 700;
}

.blue-button {
  background-color: #EEF2F9;
  color: #012579;
  width: 100%;
  border-radius: 12px;
  padding: 10px 0px;
  border: none;
  cursor: pointer;
  font-size: 18px;
  font-family: 'SalaryFinance';
  font-weight: 700;
  margin-top: 40px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  padding-top: 16px;
  padding-bottom: 18px;
}

.width-80 {
  width: 80%;
}

.arrow-right {
  margin-left: 10px;
  font-family: 'SalaryFinance';
  color: #FD5F5A;
  font-size: 30px;
  vertical-align: sub;
}
</style>
